var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page.fields)?_c('main',{class:_vm.$style.view},[_c('random-image-list',{attrs:{"list":_vm.page.featured}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }